import type { LegalFieldName, LegalFieldPolicy } from "@/services/profileService";

export type ProfileFormField = LegalFieldName;
export type ProfileFormValues = Record<ProfileFormField, string>;
export type DirtyFieldMap = Partial<Record<ProfileFormField, boolean>>;

export const PERSON_PERSONAL_FIELDS = [
  "first_name",
  "last_name",
  "birth_date",
  "birth_place",
  "fiscal_code",
] as const satisfies readonly ProfileFormField[];

export const REGISTERED_ADDRESS_FIELDS = [
  "registered_street",
  "registered_postal_code",
  "registered_city",
  "registered_province",
  "registered_country",
] as const satisfies readonly ProfileFormField[];

export const DOCUMENT_FIELDS = [
  "document_type",
  "document_number",
  "document_issuer",
  "document_issue_date",
  "document_expiry_date",
] as const satisfies readonly ProfileFormField[];

export const COMPANY_BUSINESS_FIELDS = [
  "company_name",
  "vat_number",
  "fiscal_code",
] as const satisfies readonly ProfileFormField[];

export const COMPANY_LEGAL_REP_FIELDS = [
  "legal_rep_name",
  ...DOCUMENT_FIELDS,
] as const satisfies readonly ProfileFormField[];

export const CONTACT_FIELDS = [
  "contact_phone",
  "contact_email",
  "pec",
  "partner_notification_channel",
  "preferred_language",
] as const satisfies readonly ProfileFormField[];

export const PAYMENT_FIELDS = [
  "iban",
  "account_holder",
] as const satisfies readonly ProfileFormField[];

export function isFieldExcluded(
  policy: LegalFieldPolicy,
  field: ProfileFormField,
): boolean {
  return policy.excluded.includes(field);
}

export function isFieldOptional(
  policy: LegalFieldPolicy,
  field: ProfileFormField,
): boolean {
  return policy.optional.includes(field);
}
